// Skeleton loaders for different components

export function ProductCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-pink-100 overflow-hidden animate-pulse flex flex-col min-h-[320px] md:min-h-[350px]">
      {/* Image skeleton - altura fixa */}
      <div className="w-full h-[180px] md:h-[200px] bg-gray-200 flex-shrink-0"></div>
      
      {/* Content skeleton */}
      <div className="p-3 flex flex-col flex-1">
        {/* Título - 2 linhas */}
        <div className="min-h-[2.5rem] mb-1 space-y-1">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
        
        {/* Descrição - 2 linhas */}
        <div className="min-h-[2.25rem] mb-2 space-y-1">
          <div className="h-3 bg-gray-200 rounded w-full"></div>
          <div className="h-3 bg-gray-200 rounded w-2/3"></div>
        </div>
        
        {/* Preço e botão - na base */}
        <div className="flex flex-col gap-2 mt-auto">
          <div className="h-5 bg-gray-200 rounded w-20"></div>
          <div className="h-8 bg-gray-200 rounded-xl w-full"></div>
        </div>
      </div>
    </div>
  );
}

export function CategoryFilterSkeleton() {
  return (
    <div className="flex space-x-2 overflow-x-auto pb-2 mb-6">
      {[1, 2, 3, 4].map(i => (
        <div
          key={i}
          className="px-4 py-2 bg-gray-200 rounded-full h-9 w-24 animate-pulse flex-shrink-0"
        ></div>
      ))}
    </div>
  );
}

export function CartItemSkeleton() {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-pink-100 animate-pulse">
      <div className="flex space-x-4">
        <div className="w-20 h-20 bg-gray-200 rounded-xl flex-shrink-0"></div>
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          <div className="flex items-center justify-between mt-2">
            <div className="h-8 w-24 bg-gray-200 rounded-lg"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function OrderCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-pink-100 animate-pulse">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-4 bg-gray-200 rounded w-32"></div>
          <div className="h-6 bg-gray-200 rounded-full w-20"></div>
        </div>
        <div className="h-3 bg-gray-200 rounded w-full"></div>
        <div className="h-3 bg-gray-200 rounded w-2/3"></div>
        <div className="border-t border-gray-100 pt-3 mt-3">
          <div className="h-5 bg-gray-200 rounded w-24"></div>
        </div>
      </div>
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
          <i className="ri-cake-3-fill text-white text-2xl"></i>
        </div>
        <p className="text-gray-600">Carregando...</p>
      </div>
    </div>
  );
}

export function ButtonSpinner({ size = 'sm' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
  };

  return (
    <div
      className={`${sizeClasses[size]} border-white border-t-transparent rounded-full animate-spin`}
    ></div>
  );
}

export function InlineSpinner({ color = 'pink' }: { color?: 'pink' | 'white' | 'gray' }) {
  const colorClasses = {
    pink: 'border-pink-500 border-t-transparent',
    white: 'border-white border-t-transparent',
    gray: 'border-gray-400 border-t-transparent',
  };

  return (
    <div className={`w-5 h-5 border-2 ${colorClasses[color]} rounded-full animate-spin`}></div>
  );
}

// Shimmer effect component
export function ShimmerCard({ className = '' }: { className?: string }) {
  return (
    <div className={`relative overflow-hidden bg-gray-200 rounded-xl ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent"></div>
      
      <style>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
        
        .animate-shimmer {
          animation: shimmer 2s infinite;
        }
      `}</style>
    </div>
  );
}

